import React from 'react';
import classNames from 'classnames';

const RepeatSettings = (props) => {
  const repeat = props.repeat.value || 'no-repeat';
  const isActive = (val) => val === repeat;

  const optionClasses = (val) => {
    return classNames(
      'btn btn-form',
      { 'active': isActive(val) }
    );
  };
  const handleChange = (val) => {
    const { onChange, repeat: { field } } = props;
    onChange(field, val);
  };
  const options = [
    { value: 'no-repeat', label: i18n.t('repeat_no') },
    { value: 'repeat', label: i18n.t('repeat_yes') },
    { value: 'repeat-x', label: i18n.t('horizontal') },
    { value: 'repeat-y', label: i18n.t('vertical') }
  ];
  const renderOption = ({ value, label }, index) => (
    <button
      className={optionClasses(value)}
      onClick={() => handleChange(value)}
      key={`repeat-${index}`}
    >
      {label}
    </button>
  );
  return (
    <div className="form-group">
      <label>{ i18n.t('background_repeat') }</label>
      <div className="btn-group">
        {options.map(renderOption)}
      </div>
    </div>
  );
};

export default RepeatSettings;
